import '.am{position:relative;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.jy{border-radius:20px;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.br{padding:1.5rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.jz{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.i4{width:2rem;}.ssr-plugin'
import '.b8{height:2rem;}.ssr-plugin'
import '.fs{border-radius:50%;}.ssr-plugin'
import '.k0{border:1px solid var(--palette-blue-800);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ag{flex-shrink:0;}.ssr-plugin'
import '.k1{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="am t jy u br n jz"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--palette-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="i4 b8 fs k0 a ab r ag k1"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--palette-blue-800)',
                height: '1.25rem',
                width: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--palette-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
